import { render, staticRenderFns } from "./UpdatePersonnel.vue?vue&type=template&id=46c7a82a&scoped=true&"
import script from "./UpdatePersonnel.vue?vue&type=script&lang=js&"
export * from "./UpdatePersonnel.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePersonnel.vue?vue&type=style&index=0&id=46c7a82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7a82a",
  null
  
)

export default component.exports